import script from "./movable.vue?vue&type=script&setup=true&lang=js"
export * from "./movable.vue?vue&type=script&setup=true&lang=js"

import "./movable.vue?vue&type=style&index=0&id=9e11e534&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e11e534"]])

export default __exports__